'use strict';

var RuntimeConfig = require('../runtime-config/RuntimeConfig.cjs');

class ConfigFactory {
  #config;
  constructor(additionalConfig) {
    this.#config = {
      ...new RuntimeConfig.RuntimeConfig({
        runtimeConfigKeys: __FLEX_GLOBAL_CONFIG__.MF_APP_CLIENT_RUNTIME_CONFIG_KEYS,
        appId: __FLEX_GLOBAL_CONFIG__.MF_APP_ID
      }).values,
      ...additionalConfig
    };
  }
  create() {
    return this.#config;
  }
}

exports.ConfigFactory = ConfigFactory;
//# sourceMappingURL=ConfigFactory.cjs.map
